/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import ExpenseBreadcrumbs from 'domain/finance/expenses/shared/ExpenseBreadcrumbs';

const CreateExpenseBreadcrumbs = () => {
  return (
    <ExpenseBreadcrumbs>
      <CreateBreadcrumbItem entity="Expense" />
    </ExpenseBreadcrumbs>
  );
};

export default CreateExpenseBreadcrumbs;
